// extracted by mini-css-extract-plugin
module.exports = {"container":"_3N254I","name":"_16V_3z","model":"r-XTBQ","wait-time":"_3GY4Rx","compact":"_3_4juU"};